import { useEffect, useState, useRef } from 'react';
import { useReactToPrint, } from 'react-to-print';

import { Button, Form, Col, Table, } from 'react-bootstrap';
import {
  Container,
  TablePagination,
  Paper,
  makeStyles,
  CircularProgress,
} from '@material-ui/core';
import PrintIcon from '@material-ui/icons/Print';
import { green } from '@material-ui/core/colors';
import SaveIcon from '@material-ui/icons/Save';

import NavBar from '../../components/NavBar/NavBar';
import DateIntervalSelector from '../../components/DateIntervalSelector/index';

import api from '../../services/api';

import ToastAnimated, { showToast } from '../../ui-lib/toast';
import 'react-toastify/dist/ReactToastify.css';


const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -10,
  },
}));


function EmpresasEdit() {
  const [empresa, setEmpresa] = useState([])
  const [total, setTotal] = useState('')
  const localEmpresas = JSON.parse(localStorage.getItem('empresas'))
  const empresaId = localStorage.getItem('idEmpresa')

  const classes = useStyles()
  const [pacote, setPacote] = useState()
  const [contrato, setContrato] = useState()

  const [statusSalvar, setStatusSalvar] = useState('Salvar')
  const [loading, setLoading] = useState(false)
  const timer = useRef()
  const [buttonClassname, setButtonClassname] = useState('dark')
  const [borderError, setBorderError] = useState('')

  const [rowsPerPage, setRowsPerPage] = useState(5)
  const [page, setPage] = useState(0)


  function refreshPage(info) {
    window.location.reload(info)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const componentRef = useRef()
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  })

  function getRelatorio(start, end) {
    api
      .get('/relatorios', {
        params: {
          idEmpresa: empresaId,
          inicial: start,
          final: end,
        },
      })
      .then((response) => {
        const result = response.data.chamados
        const total = response.data.sum
        setEmpresa(result)
        setTotal(total[0])
      })
      .catch((err) => {
        console.error(err)
        alert('Erro ao obter dados da empresa')
      })
  }

  useEffect(() => {
    getRelatorio()
  }, [])

  const handleButtonClick = () => {
    if (!contrato) {
      setBorderError('#ff0000')
      return showToast({
        type: 'error',
        message: 'O contrato não pode ser vazio',
      })
    }
    if (!loading) {
      api
        .post('/update/empresas', {
          id: empresaId,
          contrato: contrato,
          pacote_horas: pacote,
        })
        .then(() => {
          setButtonClassname('warning')
          setLoading(true)
          setStatusSalvar('Salvando')
          timer.current = window.setTimeout(() => {
            setButtonClassname('success')
            setLoading(false)
            setStatusSalvar('Salvo')
            refreshPage()
          }, 2000)
        })
        .catch(({ data }) => {
          console.log(data)
          return showToast({
            type: 'error',
            message: 'Erro ao criar ao criar empresa',
          })
        })
    }
  }


  return (
    <NavBar >
      <div>
        <div>
          <Container
            maxWidth="xl"
            component={Paper}
            elevation={3}
          >
            <br />
            {localEmpresas.map((body) => {
              if (body._id === empresaId) {
                return (
                  <Form>
                    <Form.Row>
                      <Form.Group as={Col}>
                        <Form.Label>Nome</Form.Label>
                        <Form.Control value={body.name} disabled />
                      </Form.Group>
                    </Form.Row>
                    <Form.Row>
                      <Form.Group as={Col}>
                        <Form.Label>
                          Pacote de horas atual ({body.pacote_horas})
                        </Form.Label>
                        <Form.Control
                          as="select"
                          defaultValue="Escolha um pacote"
                          onChange={(event) => {
                            setPacote(event.target.value)
                          }}
                        >
                          <option>Escolha um pacote</option>
                          <option>300</option>
                          <option>600</option>
                        </Form.Control>
                        <br />
                        <Form.Label>Pacote de horas (Manual)</Form.Label>
                        <Form.Control
                          placeholder={body.pacote_horas}
                          onChange={(event) => {
                            setPacote(event.target.value)
                          }}
                        ></Form.Control>
                      </Form.Group>
                      <Form.Group as={Col}>
                        <Form.Label>
                          Tipo do Contrato atual ({body.contrato})
                        </Form.Label>
                        <Form.Control
                          as="select"
                          style={{ borderColor: borderError }}
                          defaultValue="Escolha um tipo de contrato"
                          onChange={(event) => {
                            setContrato(event.target.value)
                          }}
                        >
                          <option>Escolha um tipo de contrato</option>
                          <option>Avulsa</option>
                          <option>Pacote</option>
                          <option>Contrato</option>
                        </Form.Control>
                      </Form.Group>
                    </Form.Row>
                    <div className={classes.wrapper}>
                      <ToastAnimated />
                      <Button
                        variant={buttonClassname}
                        disabled={loading}
                        onClick={handleButtonClick}
                      >
                        <SaveIcon /> {statusSalvar}
                      </Button>
                      {loading && (
                        <CircularProgress
                          size={24}
                          className={classes.buttonProgress}
                        />
                      )}
                      <ToastAnimated />
                    </div>
                  </Form>
                )
              }
            })}

            <DateIntervalSelector onSubmit={({ start, end, }) => getRelatorio(start, end)} />

            <Table
              hover
              responsive
              ref={componentRef}
              style={{
                marginTop: '1rem',
              }}
            >
              <thead>
                <tr>
                  <th>Requerente</th>
                  <th>Problema</th>
                  <th>Solução</th>
                  <th>Tempo gasto</th>
                  <th>Data</th>
                </tr>
              </thead>
              <tbody>
                {empresa
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((empresa) => {
                    return (
                      <tr key={empresa.id}>
                        <td>{empresa.id_user}</td>
                        <td>{empresa.corpo_chamado}</td>
                        <td>{empresa.msg}</td>
                        <td>{empresa.temp_g}</td>
                        <td>
                          {new Date(empresa.data_abertura).toLocaleDateString()}
                        </td>
                      </tr>
                    )
                  })}
                <tr
                  style={{
                    fontWeight: 'bold',
                    fontSize: '22px',
                  }}
                >
                  <td colSpan="3">Total de minutos usados durante o período</td>
                  <td colSpan="3">{total.soma}</td>
                </tr>
              </tbody>
            </Table>

            <TablePagination
              rowsPerPageOptions={[
                5,
                10,
                25,
                50,
                100,
                200,
                300,
                500,
                1000,
                2000,
              ]}
              component="div"
              count={empresa.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
            <Button onClick={handlePrint} variant="light">
              <PrintIcon />
              Imprimir esse relatorio
            </Button>
            <br />
            <br />
          </Container>
          <br />
        </div>
      </div>
    </NavBar>
  );
}

export default EmpresasEdit;
